import { Facebook, Twitter, Instagram, Youtube } from "lucide-react";
import { useI18n } from "../i18n";
import { scrollToId } from "./SmoothScroll";

export const Footer = () => {
  const { t } = useI18n();
  const go = (id) => scrollToId(id);
  const navLinks = [["nav.vision", "vision"], ["nav.programme", "programme"], ["nav.bio", "biographie"], ["nav.adhesion", "adhesion"]];

  return (
    <footer className="bg-[#0B1121] text-white/70 pt-16 pb-8 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3">
              <span className="flex items-center justify-center h-12 w-12 rounded-full bg-white border border-white/20 shrink-0">
                <img src="/prr-logo.png" alt="Logo PRR" className="h-8 w-8 object-contain" />
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-display font-extrabold tracking-tighter text-lg text-white">Gilles de Buretel de Chassey</span>
                <span className="font-mono-accent text-[10px] uppercase tracking-[0.2em] text-[#38BDF8] mt-1">PRR · Parti du Reset et de la Relance</span>
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed">{t("foot.desc")}</p>
            <div className="mt-6 flex gap-3">
              {[Facebook, Twitter, Instagram, Youtube].map((Icon, i) => (
                <a key={i} href="#" data-testid={`social-${i}`}
                  className="w-10 h-10 rounded-full border border-white/15 flex items-center justify-center hover:bg-white hover:text-[#0B1121] transition-colors">
                  <Icon size={18} />
                </a>
              ))}
            </div>
          </div>
          <div>
            <h4 className="font-mono-accent text-xs uppercase tracking-widest text-white mb-4">{t("foot.nav")}</h4>
            <ul className="space-y-2 text-sm">
              {navLinks.map(([k, id]) => (
                <li key={id}><button onClick={() => go(id)} className="hover:text-white transition-colors">{t(k)}</button></li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-mono-accent text-xs uppercase tracking-widest text-white mb-4">{t("foot.agir")}</h4>
            <ul className="space-y-2 text-sm">
              <li><button onClick={() => go("soutenir")} className="hover:text-white transition-colors">{t("nav.cta")}</button></li>
              <li><button onClick={() => go("adhesion")} className="hover:text-white transition-colors">{t("nav.adhesion")}</button></li>
              <li><a href="mailto:president@reset-relance.org" className="hover:text-white transition-colors">president@reset-relance.org</a></li>
            </ul>
            <p className="mt-4 text-xs text-white/50 leading-relaxed">{t("foot.accessible")}</p>
          </div>
        </div>
        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-xs">
          <p>{t("foot.copyright")}</p>
          <p>{t("foot.legal")}</p>
        </div>
      </div>
    </footer>
  );
};
